import {ChainedCommands} from '@tiptap/core';
import {Editor} from '@tiptap/react';

export function hasTextRangeSelection(editor: Editor | null | undefined): boolean {
    if (!editor || editor.isDestroyed) return false;
    const {empty, from, to} = editor.state.selection;
    return !empty && from !== to;
}

export function applyTextStyleCommand(editor: Editor, command: (chain: ChainedCommands) => ChainedCommands): void {
    if (editor.isDestroyed) return;
    editor.setEditable(true);
    command(editor.chain().focus()).run();
}
